import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["details", "toggle"]

  connect() {
    console.log("Panel details controller connected")
  }

  toggle() {
    this.detailsTarget.classList.toggle("hidden")
    this.toggleTarget.querySelector("svg").classList.toggle("rotate-180")
    
    if (!this.detailsTarget.classList.contains("hidden")) {
      this.toggleTarget.querySelector("span").textContent = "Hide Details"
    } else {
      this.toggleTarget.querySelector("span").textContent = "Show Details"
    }
  }
}
